

const FilterIcon = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#868FA0" d="M34.4749 6.53911C35.7573 4.89776 34.5878 2.5 32.5049 2.5H7.50464C5.42177 2.5 4.25227 4.89775 5.53458 6.53911L17.5996 21.8217C17.943 22.2612 18.1295 22.803 18.1295 23.3608V36.9902C18.1295 37.4356 18.6681 37.6587 18.9831 37.3438L21.5134 34.8134C21.7478 34.579 21.8795 34.2611 21.8795 33.9295V23.3608C21.8795 22.803 22.0661 22.2612 22.4095 21.8217L34.4749 6.53911Z" />
        </svg>
    )
}
export default FilterIcon;